import { IAttribute, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Activity } from './activity';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { InvokeCopyJobLinkedService } from '../linkedservice/invoke-copyjob.linkedservice';
import { format } from '../../shared/utils/string.util';
import { ParameterValue } from '../base/parameter-value';
import { LinkedService } from '../linkedservice/linkedservice';

@Metamodel.model({
    name: ModelConstants.invokeCopyJob,
    referable: true
})
export class InvokeCopyJobActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly COPYJOBID: IAttribute;
    public static readonly WORKSPACEID: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;
    public static readonly FAILONEMPTYOUTPUT: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ConnectionLabel,
        reference: true,
        type: InvokeCopyJobLinkedService.MODEL,
        constraint: {
            validator: InvokeCopyJobActivity.validateConnection
        }
    })
    public invokeCopyJobLinkedService: InvokeCopyJobLinkedService;

    @Metamodel.attribute({
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters?: ParameterValue[] = [];

    @Metamodel.attribute({
        display: shellStringResources.CopyJobIdLabel,
        association: 'COPYJOBID',
        constraint: {
            validator: InvokeCopyJobActivity.validateCopyJob
        },
        templatable: true
    })
    public copyJobId: string;

    @Metamodel.attribute({
        display: shellStringResources.TridentWorkspaceLabel,
        association: 'WORKSPACEID',
        constraint: {
            validator: InvokeCopyJobActivity.validateWorkspace
        },
        templatable: true
    })
    public workspaceId: string;

    @Metamodel.attribute({
        association: 'FAILONEMPTYOUTPUT',
        templatable: true
    })
    public failOnEmptyOutput?: boolean;

    private static validateCopyJob(_invokeCopyJobActivity?: InvokeCopyJobActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.CopyJobLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateWorkspace(_invokeCopyJobActivity?: InvokeCopyJobActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.TridentWorkspaceLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateConnection(_invokeCopyJobActivity?: InvokeCopyJobActivity, linkedService?: LinkedService): IViolation[] | undefined {
        if (!linkedService) {
            return [
                {
                    message: () => format(shellStringResources.RequiredConnectionTemplate, shellStringResources.CopyJobLabel, shellStringResources.ConnectionLabel)
                }
            ];
        } else if (linkedService && linkedService.getLinkedServiceType() != Metamodel.modelFor(InvokeCopyJobLinkedService).name) {
            return [
                {
                    message: () =>
                        format(
                            shellStringResources.ActivityNotSupportLinkedServiceError,
                            format(shellStringResources.ModelName_ActivityTemplate, shellStringResources.CopyJobLabel),
                            format(shellStringResources.ModelName_ConnectionTemplate, Metamodel.modelOf(linkedService).name)
                        ),
                    messageType: 'unsupported'
                }
            ];
        }
        return undefined;
    }
}
